// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

// const firebaseConfig = {
//   apiKey: "AIzaSyDEwxRwXjLf7WBJryRCXQ4hMubHDhxcrzs",
//   authDomain: "thebooker-f60a2.firebaseapp.com",
//   databaseURL: "https://thebooker-f60a2-default-rtdb.firebaseio.com",
//   projectId: "thebooker-f60a2",
//   storageBucket: "thebooker-f60a2.appspot.com",
//   messagingSenderId: "736332955450",
//   appId: "1:736332955450:web:4305be98e67a0eaa8fda03",
//   measurementId: "G-WM4HD8ZPSK"
// };

const firebaseConfig = {
  apiKey: 'AIzaSyDmupVZpty-qe19gABTOwf1G0KwdD4DmE4',
  projectId: 'the-booker-1fdf9',
  storageBucket:'the-booker-1fdf9.appspot.com',
  messagingSenderId:'',
  databaseURL: 'https://the-booker-1fdf9-default-rtdb.firebaseio.com', // <-- Ensure you have this property
  appName: 'thebooker', // Project Name
  appId: '1:985235070113:android:7b17f540cef206998164e0', // Project ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export {app , db};